var render = function () {
  var _vm$inputs, _vm$inputs$program, _vm$inputs2, _vm$inputs2$program;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "900",
      "persistent": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-card', {
    attrs: {
      "height": "100%"
    }
  }, [_c('v-card-title', [_vm.isCreate ? [_vm._v("작품 생성")] : [_vm._v("작품 상세")], _c('v-spacer'), _c('v-icon', {
    on: {
      "click": function click($event) {
        _vm.shows = false;
      }
    }
  }, [_vm._v("mdi-close")])], 2), _c('v-divider'), _vm.isLoaded ? _c('v-card-text', {
    staticClass: "pa-0",
    staticStyle: {
      "max-height": "calc(90vh - 120px)",
      "overflow-y": "auto"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-card-subtitle', [_vm._v("이미지")]), _c('v-divider'), _c('v-responsive', {
    attrs: {
      "aspect-ratio": 1 / 1
    }
  }, [_c('v-card-text', [_vm.imgSrcs.length ? _c('v-tabs-items', {
    attrs: {
      "value": _vm.image_selected
    }
  }, _vm._l(_vm.imgSrcs, function (src) {
    return _c('v-tab-item', {
      key: src
    }, [_c('v-responsive', {
      attrs: {
        "aspect-ratio": 1 / 1
      }
    }, [_c('work-imgs-overlay', {
      attrs: {
        "imgs": _vm.imgSrcs.map(function (url) {
          return {
            url: url
          };
        }),
        "disableLink": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function fn(_ref2) {
          var attrs = _ref2.attrs,
            on = _ref2.on,
            setIndex = _ref2.setIndex;
          return [_c('v-img', _vm._g(_vm._b({
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "src": src,
              "width": "100%",
              "aspect-ratio": 1 / 1
            },
            on: {
              "click": function click($event) {
                return setIndex({
                  url: src
                });
              }
            }
          }, 'v-img', attrs, false), on))];
        }
      }], null, true)
    })], 1)], 1);
  }), 1) : _c('v-img', {
    attrs: {
      "aspect-ratio": 1 / 1
    }
  }, [_c('v-overlay', {
    attrs: {
      "absolute": "",
      "z-index": "0",
      "color": "grey darken-1"
    }
  }, [_vm._v("이미지가 없습니다")])], 1)], 1)], 1), _c('v-divider'), _c('v-card-actions', [_c('images-input', {
    on: {
      "mouseover": _vm.setImage_selected
    },
    model: {
      value: _vm.inputs.imgs,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs, "imgs", $$v);
      },
      expression: "inputs.imgs"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "auto"
    }
  }, [_c('v-divider', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isMobile,
      expression: "!isMobile"
    }],
    attrs: {
      "vertical": ""
    }
  }), _c('v-divider', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isMobile,
      expression: "isMobile"
    }]
  })], 1), _c('v-col', [_c('v-card-subtitle', [_vm._v("기본 정보")]), _c('v-divider'), _c('v-card-text', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "mr-3"
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "LOT"
    },
    model: {
      value: _vm.inputs.lot,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs, "lot", $$v);
      },
      expression: "inputs.lot"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', [_c('v-select', _vm._b({
    attrs: {
      "label": "작품타입",
      "items": [{
        text: '평면',
        value: false
      }, {
        text: '입체',
        value: true
      }]
    },
    model: {
      value: _vm.inputs.dimension.is3D,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs.dimension, "is3D", $$v);
      },
      expression: "inputs.dimension.is3D"
    }
  }, 'v-select', _vm.attrs_input, false))], 1)], 1), _c('v-row', {
    staticClass: "my-3",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "mr-3"
  }, [_c('v-select', _vm._b({
    attrs: {
      "label": "작가",
      "items": _vm.authors,
      "item-text": "nameTag.ko",
      "return-object": ""
    },
    model: {
      value: _vm.inputs.author,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs, "author", $$v);
      },
      expression: "inputs.author"
    }
  }, 'v-select', _vm.attrs_input, false))], 1), _c('v-col', [_c('author-view', {
    on: {
      "input": _vm.addAuthor
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref3) {
        var attrs = _ref3.attrs,
          on = _ref3.on;
        return [_c('v-tooltip', {
          attrs: {
            "right": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(tooltip) {
              return [_c('v-btn', _vm._g(_vm._b({
                attrs: {
                  "text": "",
                  "icon": ""
                }
              }, 'v-btn', Object.assign({}, attrs, tooltip.attrs), false), Object.assign({}, on, tooltip.on)), [_c('v-icon', [_vm._v("mdi-account-plus")])], 1)];
            }
          }], null, true)
        }, [_vm._v(" 작가추가 ")])];
      }
    }], null, false, 591709158)
  })], 1)], 1), _c('v-text-field', _vm._b({
    staticClass: "my-3",
    attrs: {
      "label": "작품명"
    },
    model: {
      value: _vm.inputs.subject,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs, "subject", $$v);
      },
      expression: "inputs.subject"
    }
  }, 'v-text-field', _vm.attrs_input, false)), _c('v-row', {
    staticClass: "my-3",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "mr-3"
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "연도"
    },
    model: {
      value: _vm.inputs.year,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs, "year", $$v);
      },
      expression: "inputs.year"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', [_c('v-text-field', _vm._b({
    attrs: {
      "label": "재료"
    },
    model: {
      value: _vm.inputs.material,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs, "material", $$v);
      },
      expression: "inputs.material"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1)], 1), _c('v-row', {
    staticClass: "my-3",
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_vm.inputs.dimension.is3D ? [_c('v-col', {
    staticClass: "mr-3"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "mr-3"
  }, [_c('v-text-field', _vm._b({
    staticClass: "input--text-align-right",
    attrs: {
      "label": "가로",
      "type": "number"
    },
    model: {
      value: _vm.inputs.dimension.w,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs.dimension, "w", $$v);
      },
      expression: "inputs.dimension.w"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', {
    staticClass: "mr-3",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("X")]), _c('v-col', [_c('v-text-field', _vm._b({
    staticClass: "input--text-align-right",
    attrs: {
      "label": "세로",
      "type": "number"
    },
    model: {
      value: _vm.inputs.dimension.h,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs.dimension, "h", $$v);
      },
      expression: "inputs.dimension.h"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1)], 1)], 1), _c('v-col', [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "mr-3",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("X")]), _c('v-col', {
    staticClass: "mr-3"
  }, [_c('v-text-field', _vm._b({
    staticClass: "input--text-align-right",
    attrs: {
      "label": "높이",
      "type": "number"
    },
    model: {
      value: _vm.inputs.dimension.d,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs.dimension, "d", $$v);
      },
      expression: "inputs.dimension.d"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', [_c('v-select', _vm._b({
    attrs: {
      "label": "단위",
      "items": ['cm', 'inch']
    },
    model: {
      value: _vm.inputs.dimension.unit,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs.dimension, "unit", $$v);
      },
      expression: "inputs.dimension.unit"
    }
  }, 'v-select', _vm.attrs_input, false))], 1)], 1)], 1)] : [_c('v-col', {
    staticClass: "mr-3"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "mr-3"
  }, [_c('v-text-field', _vm._b({
    staticClass: "input--text-align-right",
    attrs: {
      "label": "가로",
      "type": "number"
    },
    model: {
      value: _vm.inputs.dimension.w,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs.dimension, "w", $$v);
      },
      expression: "inputs.dimension.w"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', {
    staticClass: "mr-3",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("X")]), _c('v-col', [_c('v-text-field', _vm._b({
    staticClass: "input--text-align-right",
    attrs: {
      "label": "세로",
      "type": "number"
    },
    model: {
      value: _vm.inputs.dimension.h,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs.dimension, "h", $$v);
      },
      expression: "inputs.dimension.h"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1)], 1)], 1), _c('v-col', [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "mr-3"
  }, [_c('v-select', _vm._b({
    attrs: {
      "label": "단위",
      "items": ['cm', 'inch']
    },
    model: {
      value: _vm.inputs.dimension.unit,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs.dimension, "unit", $$v);
      },
      expression: "inputs.dimension.unit"
    }
  }, 'v-select', _vm.attrs_input, false))], 1), _c('v-col', [_c('v-text-field', _vm._b({
    attrs: {
      "label": "호수",
      "type": "number",
      "suffix": "호"
    },
    model: {
      value: _vm.inputs.dimension.code,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs.dimension, "code", $$v);
      },
      expression: "inputs.dimension.code"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1)], 1)], 1)]], 2), _c('v-textarea', _vm._b({
    attrs: {
      "label": "설명",
      "auto-grow": "",
      "rows": "3"
    },
    model: {
      value: _vm.inputs.content,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs, "content", $$v);
      },
      expression: "inputs.content"
    }
  }, 'v-textarea', _vm.attrs_input, false))], 1)], 1)], 1), _c('v-divider'), _c('v-card-subtitle', [_vm._v("경매 정보")]), _c('v-divider'), _c('v-card-text', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "mr-3"
  }, [_c('work-view-mode', {
    model: {
      value: _vm.inputs,
      callback: function callback($$v) {
        _vm.inputs = $$v;
      },
      expression: "inputs"
    }
  })], 1), _c('v-col', {
    staticClass: "mr-3"
  }, [_c('v-select', _vm._b({
    attrs: {
      "label": "프로그램",
      "items": _vm.programs,
      "item-text": "subject",
      "return-object": "",
      "disabled": _vm.inputs.mode_auction !== _vm.PROGRAM.value
    },
    on: {
      "input": _vm.setDuration
    },
    model: {
      value: _vm.inputs.program,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs, "program", $$v);
      },
      expression: "inputs.program"
    }
  }, 'v-select', _vm.attrs_input, false))], 1), _c('v-col', {
    staticClass: "mr-3"
  }, [_c('v-select', _vm._b({
    attrs: {
      "label": "그룹",
      "items": ((_vm$inputs = _vm.inputs) === null || _vm$inputs === void 0 ? void 0 : (_vm$inputs$program = _vm$inputs.program) === null || _vm$inputs$program === void 0 ? void 0 : _vm$inputs$program.groups) || [],
      "disabled": (((_vm$inputs2 = _vm.inputs) === null || _vm$inputs2 === void 0 ? void 0 : (_vm$inputs2$program = _vm$inputs2.program) === null || _vm$inputs2$program === void 0 ? void 0 : _vm$inputs2$program.groups) || []).length < 1
    },
    model: {
      value: _vm.inputs.group,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs, "group", $$v);
      },
      expression: "inputs.group"
    }
  }, 'v-select', _vm.attrs_input, false))], 1), _c('v-col')], 1), _c('v-expand-transition', [_c('v-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.inputs.mode_auction == _vm.PROGRAM.value,
      expression: "inputs.mode_auction == PROGRAM.value"
    }],
    staticClass: "my-3",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "mr-3"
  }, [_c('v-currency-field', _vm._b({
    staticClass: "input--text-align-right",
    attrs: {
      "label": "추정금액(최소)",
      "prefix": "KRW"
    },
    model: {
      value: _vm.inputs.price_estimated.from,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs.price_estimated, "from", $$v);
      },
      expression: "inputs.price_estimated.from"
    }
  }, 'v-currency-field', _vm.attrs_input, false))], 1), _c('v-col', {
    staticClass: "mr-3"
  }, [_c('v-currency-field', _vm._b({
    staticClass: "input--text-align-right",
    attrs: {
      "label": "추정금액(최대)",
      "prefix": "KRW"
    },
    model: {
      value: _vm.inputs.price_estimated.to,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs.price_estimated, "to", $$v);
      },
      expression: "inputs.price_estimated.to"
    }
  }, 'v-currency-field', _vm.attrs_input, false))], 1), _c('v-col', {
    staticClass: "mr-3"
  }, [_c('v-currency-field', _vm._b({
    staticClass: "input--text-align-right",
    attrs: {
      "label": "경매시작금액",
      "prefix": "KRW"
    },
    model: {
      value: _vm.inputs.price_auction.from,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs.price_auction, "from", $$v);
      },
      expression: "inputs.price_auction.from"
    }
  }, 'v-currency-field', _vm.attrs_input, false))], 1), _c('v-col', [_c('v-currency-field', _vm._b({
    staticClass: "input--text-align-right",
    attrs: {
      "label": "경매금액단위",
      "prefix": "KRW",
      "disabled": ""
    },
    model: {
      value: _vm.inputs.price_auction.unit,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs.price_auction, "unit", $$v);
      },
      expression: "inputs.price_auction.unit"
    }
  }, 'v-currency-field', _vm.attrs_input, false))], 1)], 1)], 1), _c('v-expand-transition', [_c('v-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.inputs.mode_auction == _vm.PROGRAM.value,
      expression: "inputs.mode_auction == PROGRAM.value"
    }],
    staticClass: "my-n3",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "mr-3"
  }, [_c('row-date-time', {
    attrs: {
      "label": "경매기간-시작",
      "attrs_input": _vm.attrs_input
    },
    model: {
      value: _vm.inputs.duration_auction.startsAt,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs.duration_auction, "startsAt", $$v);
      },
      expression: "inputs.duration_auction.startsAt"
    }
  })], 1), _c('v-col', [_c('row-date-time', {
    attrs: {
      "label": "경매기간-종료",
      "attrs_input": _vm.attrs_input
    },
    model: {
      value: _vm.inputs.duration_auction.endsAt,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs.duration_auction, "endsAt", $$v);
      },
      expression: "inputs.duration_auction.endsAt"
    }
  })], 1)], 1)], 1), _c('v-expand-transition')], 1), _c('v-divider'), _c('v-card-subtitle', {
    staticStyle: {
      "position": "relative"
    }
  }, [_vm._v(" 상세 정보 "), _c('v-tooltip', {
    attrs: {
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref4) {
        var attrs = _ref4.attrs,
          on = _ref4.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "mt-n2 ml-1",
          attrs: {
            "text": "",
            "icon": "",
            "absolute": ""
          },
          on: {
            "click": _vm.initClassifications
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-cloud-download")])], 1)];
      }
    }], null, false, 2055749384)
  }, [_vm._v(" 기본값 불러오기 ")])], 1), _c('v-divider'), _c('work-view-classifications', {
    model: {
      value: _vm.inputs.classifications,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs, "classifications", $$v);
      },
      expression: "inputs.classifications"
    }
  })], 1) : _c('v-card-text', {
    staticClass: "d-flex justify-center align-center",
    staticStyle: {
      "height": "calc(90vh - 120px)",
      "overflow-y": "auto"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": "5"
    }
  })], 1), _c('v-divider'), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "large": "",
      "outlined": ""
    },
    on: {
      "click": _vm.init
    }
  }, [_vm._v("초기화")]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "large": "",
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(" 저장하기 ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }